import React, { Component } from "react";
import { connect } from "react-redux";
import { reduxForm } from "redux-form";
import { Alert, Form, FormGroup } from "react-bootstrap";

import Accordion from "./Accordion";
import Button from "../../../../components/common/button/Button";
import Steps from "../../../../components/common/steps/Steps";
import ScrollToTopOnMount from "../../../../utils/scroll/ScrollToTopOnMount";

import { getProject } from "../../../../actions/project.actions";

import styles from "./ProjectSkills.scss";
import errorStyles from "../../../../components/common/error/Error.scss";

class ProjectSkills extends Component {
  constructor(props) {
    super(props);
    this.state = {
      categoriesChecked: [],
      defaultValueRadio: "",
      selection: [{}, {}, {}, {}, {}, {}, {}],
      sk: 0,
      cat: 0,
      flag: false
    };
    this.handleChangeRadio = this.handleChangeRadio.bind(this);
    this.validateCheckbox = this.validateCheckbox.bind(this);
  }

  componentDidUpdate(prevState, prevProps) {
    if (
      prevState != this.state &&
      prevProps.initialValues != this.props.initialValues &&
      !this.state.flag
    ) {
      if (_.get(this.props.initialValues, "must_skills")) {
        this.props.initialValues.must_skills.forEach(skill => {
          this.centralCount(
            skill.skill_id,
            skill.description.category_id,
            "MUST_HAVE",
            0
          );
        });
      }
      if (_.get(this.props.initialValues, "nice_skills")) {
        this.props.initialValues.nice_skills.forEach(skill => {
          this.centralCount(
            skill.skill_id,
            skill.description.category_id,
            "NICE_HAVE",
            0
          );
        });
      }
      this.setState({ flag: true });
    }
  }

  centralCount(id, category, value, type) {
    let selection = this.state.selection;
    if (type === 0) {
      //change in must/nice
      selection[category - 1][id] = { val: value }; //falsy
    } else {
      //handle opened/closed
      if (selection[category - 1][id]) {
        //if it's open
        delete selection[category - 1][id]; //falsy
      } else {
        selection[category - 1][id] = {}; //truthy
      }
    }
    let skillCount = 0;
    let catCount = 0;
    selection.forEach(cat => {
      let flag = false;
      Object.keys(cat).forEach(sk => {
        if (cat[sk] && cat[sk].val == "MUST_HAVE") {
          flag = true;
          skillCount = skillCount + 1;
        }
      });
      if (flag) catCount = catCount + 1;
    });
    this.setState({ selection: selection, sk: skillCount, cat: catCount });
  }

  handleChangeRadio(event, value, other, callback) {
    this.centralCount(other.id, other.cat, value, 0);
    callback();
  }

  validateCheckbox(value, index, count, callback) {
    this.centralCount(value.id, index + 1, value, 1);
    this.setState(prevState => {
      const existItem = [...prevState.categoriesChecked].find(
        item => item.index === index
      );
      let newcategoriesChecked;
      if (!existItem) {
        newcategoriesChecked = [...prevState.categoriesChecked, { index }];
      } else {
        if (count) {
          newcategoriesChecked = [...prevState.categoriesChecked];
        } else {
          newcategoriesChecked = [...prevState.categoriesChecked].filter(
            item => item.index !== index
          );
        }
      }
      if (!_.isEmpty(this.props.formValues.skills)) {
        this.setState(
          {
            cat: newcategoriesChecked.length,
            categoriesChecked: newcategoriesChecked,
            defaultValueRadio: ""
          },
          () => {
            callback();
          }
        );

        return { valid: count < 0 ? false : prevState.count };
      } else {
        return { valid: false };
      }
    });
  }

  render() {
    const { initialValues, submitting } = this.props;
    const { sk, cat } = this.state;

    let selectedArray = new Array(7).fill(0);
    if (_.get(initialValues, "must_skills")) {
      initialValues.must_skills.forEach(skill => {
        selectedArray[skill.description.category_id - 1] += 1;
      });
    }
    if (_.get(initialValues, "nice_skills")) {
      initialValues.nice_skills.forEach(skill => {
        selectedArray[skill.description.category_id - 1] += 1;
      });
    }

    return (
      <section className={styles.projectSkills}>
        <ScrollToTopOnMount />
        <div className={styles.header}>
          <Steps steps={this.props.steps} activeStep={2} track={true} />
        </div>
        <div className={styles.content}>
          <h2 className={styles.title}>Categories + Skills</h2>

          <Form onSubmit={this.props.handleSubmit}>
            <div className={styles.form}>
              <FormGroup>
                <div className={styles.subtitle}>
                  Skills marked as “must have” influence your matches. Skills
                  marked as “nice to have” do not, but they help Members decide
                  how to pitch your project.
                </div>
                <div className={styles.subtitle}>
                  Limit of 5 "must have" skills. Unlimited "nice to have
                  skills".
                </div>
              </FormGroup>
              <FormGroup>
                <div className={styles.dividerDouble} />

                <FormGroup>
                  <div className={styles.accordion}>
                    {this.props.skills &&
                      this.props.skills.map((el, index) => (
                        <Accordion
                          category={
                            this.props.formValues &&
                            this.props.formValues.category_id
                          }
                          key={el.id}
                          selectedSkills={this.props.formValues.skills}
                          selectedNumber={selectedArray[index]}
                          name={el.name}
                          category={el.id}
                          submitting={this.state.submitting}
                          props={{ submitting: this.state.submitting }}
                          onChangeRadio={this.handleChangeRadio}
                          handleCheck={(value, count, callback) =>
                            this.validateCheckbox(value, index, count, callback)
                          }
                          defaultValueRadio={this.state.defaultValueRadio}
                          {...el}
                        />
                      ))}
                  </div>
                </FormGroup>

                <div
                  md={12}
                  style={{ textAlign: "center" }}
                  className={styles.CTAContainer}
                >
                  <Button
                    type="submit"
                    size={"large"}
                    label="SAVE + CONTINUE"
                    isPrimary
                    isDisabled={submitting || sk == 0 || sk > 5 || cat > 2}
                    onClick={() => {
                      this.setState({ submitting: true, flag: false });
                    }}
                  />
                  <div className={errorStyles.errorBox}>
                    {cat > 2 && (
                      <Alert bsStyle="danger">
                        Please limit your must-have skills to two categories
                        only.
                      </Alert>
                    )}
                  </div>
                </div>
              </FormGroup>
            </div>
          </Form>
        </div>
      </section>
    );
  }
}

ProjectSkills = reduxForm({
  form: "projectSkills",
  enableReinitialize: true
})(ProjectSkills);

ProjectSkills = connect(
  state => {
    return {
      initialValues: state.project.data.data
    };
  },
  dispatch => {
    return {
      getProject: () => dispatch(getProject())
    };
  }
)(ProjectSkills);

export default ProjectSkills;



// WEBPACK FOOTER //
// ./src/routes/employer/project/components/ProjectSkills.js